import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'bolt-icon',
  templateUrl: './bolt-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BoltIconComponent {}
